import { Badge } from "react-bootstrap";
import { STATUS_BADGE } from "../../BcaAttendance/components/StudentSession";

const columns = [
    {
        Header: "S.no",
        width: "70",
        Cell: ({ row }) => {
            return row.index + 1;
        },
    },
    {
        Header: "Student Name",
        accessor: "enrolment.name",
        width: "300"
    },
    {
        Header: "FIN",
        accessor: "enrolment.fin",
        width: "200"
    },
    {
        Header: "Sponsor Company",
        accessor: "enrolment.sponsor_company.name",
        width: "325",
    },
    {
        Header: "Status",
        width: "150",
        Cell: ({ row }) => {
            const bca = row.original.student_training_dates?.[0]?.student_bca;
            const status = bca?.[0]?.status;
            const label =
                bca === undefined
                    ? "NOT ENROLLED"
                    : bca?.length === 0
                    ? "PENDING"
                    : status;
            return (
                <Badge
                    className={`border rounded-3 px-3 py-2 ${
                        STATUS_BADGE[label] || STATUS_BADGE.DEFAULT
                    }`}
                >
                    <span className="fw-bold">{label}</span>
                </Badge>
            );
        },
    },
];

export { columns };
